<template>
    <el-scrollbar wrapClass="scrollbar-wrapper">
        <!--
            default-active="$route.path" 路径等于当前路由，可以让路由在跳转的时候对应高亮
            unique-opened 是否只保持一个菜单展开
         -->
        <el-menu :collapse="collapse" background-color="#363C42" text-color="#fff" active-text-color="#ffd04b" router :default-active="activePath" unique-opened @select="menuSelect">
            <div class="logo">
                <img src="../../../assets/img/logoz.png" alt="">
            </div>
            <div v-for="item in menuList" :key="item.name">
                <!-- 有子菜单 -->
                <el-submenu :index="item.path" v-if="item.children&&item.children.length">
                    <template slot="title">
                        <i :class="item.meta&&item.meta.icon || 'el-icon-success'" class="icon"></i>
                        <span slot="title">{{item.meta&&item.meta.title}}</span>
                    </template>
                    <el-menu-item :index="item.path+'/'+subItem.path" v-for="subItem in item.children" :key="subItem.name">
                        <i :class="subItem.meta&&subItem.meta.icon || 'el-icon-success'" class="icon"></i>
                        <span slot="title">{{subItem.meta&&subItem.meta.title}}</span>
                    </el-menu-item>
                </el-submenu>
                <!-- 没有子菜单 -->
                <el-menu-item :index="item.path" v-else>
                    <i :class="item.meta&&item.meta.icon || 'el-icon-success'" class="icon"></i>
                    <span slot="title">{{item.meta&&item.meta.title}}</span>
                </el-menu-item>
            </div>
        </el-menu>
    </el-scrollbar>
</template>

<script>
// 递归获取权限表中menu为true的项目
function filterRouter(menuList) {
    const accesseRouters = JSON.parse(JSON.stringify(menuList)).filter(item => {
        if (item.meta.menu) {
            if (item.children && item.children.length) {
                item.children = filterRouter(item.children)
            }
            return true
        } else {
            return false
        }
    })
    return accesseRouters
}
export default {
    computed: {
        menuList() {
            return filterRouter(this.$store.state.menuList)
        },
        collapse() {
            return this.$store.state.collapse
        },
        activePath() {
            // 如果是以/index结尾的，则去掉
            if (/\/index$/.test(this.$route.path)) {
                return this.$route.path.substring(0, this.$route.path.length - 6)
            } else {
                return this.$route.path
            }
        }
    },
    methods: {
        menuSelect(path, keyPath) {

        }
    },
    created() {
    }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar.vue